var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3.87891C17.7026 3.87891 17.4174 3.99705 17.2071 4.20733L4.90299 16.5115L4.37439 18.6259L6.48877 18.0973L18.7929 5.79312C18.897 5.689 18.9796 5.56538 19.036 5.42934C19.0923 5.29329 19.1213 5.14748 19.1213 5.00023C19.1213 4.85297 19.0923 4.70716 19.036 4.57112C18.9796 4.43507 18.897 4.31146 18.7929 4.20733C18.6888 4.10321 18.5652 4.02061 18.4291 3.96426C18.2931 3.90791 18.1473 3.87891 18 3.87891ZM15.7929 2.79312C16.3783 2.20776 17.1722 1.87891 18 1.87891C18.4099 1.87891 18.8158 1.95964 19.1945 2.1165C19.5732 2.27336 19.9173 2.50328 20.2071 2.79312C20.497 3.08296 20.7269 3.42705 20.8837 3.80575C21.0406 4.18444 21.1213 4.59033 21.1213 5.00023C21.1213 5.41012 21.0406 5.81601 20.8837 6.1947C20.7269 6.5734 20.497 6.91749 20.2071 7.20733L7.70713 19.7073C7.57897 19.8355 7.41839 19.9264 7.24256 19.9704L3.24256 20.9704C2.90178 21.0556 2.54129 20.9557 2.29291 20.7073C2.04453 20.459 1.94468 20.0985 2.02988 19.7577L3.02988 15.7577C3.07384 15.5819 3.16476 15.4213 3.29291 15.2931L15.7929 2.79312ZM11 20.0002C11 19.4479 11.4477 19.0002 12 19.0002H21C21.5523 19.0002 22 19.4479 22 20.0002C22 20.5525 21.5523 21.0002 21 21.0002H12C11.4477 21.0002 11 20.5525 11 20.0002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a98598ecd8e4568da2fc77c6e3d6846a.svg";
export { ForwardRef as ReactComponent };